import { getColorsBySeed } from 'utils/getColorsBySeed';
import { RoleSimple } from 'types/user/role';
import { AppTag } from 'components/atoms';

export const RoleDisplay = ({ role }: { role: RoleSimple }) => {
    if (!role) {
        return null;
    }
    const { id, name } = role;
    const { mainColor, secondaryColor } = getColorsBySeed(name);

    return (
        <AppTag
            style={{
                color: mainColor,
                backgroundColor: secondaryColor,
            }}
            key={id}
        >
            {name}
        </AppTag>
    );
};
